export default {
      id: "expenses-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#expenses",
      toString: function () {
        return this.url;
      }
    }